import React from 'react'
import { UseFormRegister, FieldValues } from 'react-hook-form'
import { ListItem } from './list_item'

interface ListItemData<T> {
  label: string
  value: string
  fieldName: keyof T
  rows?: number
}

interface ListGroupProps<T extends FieldValues> {
  title: string
  items: ListItemData<T>[]
  isEditing: boolean
  register?: UseFormRegister<T>
}

export const ListGroup = <T extends FieldValues>({
  title,
  items,
  isEditing,
  register,
}: ListGroupProps<T>) => {
  return (
    <div>
      <p className="font-bold text-lg mb-2">{title}</p>
      {items.map((item, index) => (
        <ListItem<T>
          key={index}
          label={item.label}
          value={item.value}
          isEditing={isEditing}
          register={register}
          fieldName={item.fieldName}
          rows={item.rows}
        />
      ))}
    </div>
  )
}
